import { FC } from "react";
import { FieldValues, UseFormRegister } from "react-hook-form";

import { Field } from "@types";

import { Label } from "./Label";
import s from "./CheckboxField.module.scss";

interface Props extends Field {
  register: UseFormRegister<FieldValues>;
}

export const CheckboxField: FC<Props> = ({ label, name, options, register, required }) => (
  <>
    <Label id={name} label={label} required={required} />
    <div>
      {options?.map((option) => (
        <div className={s.Checkbox} key={`${option.label}-${option.value}`}>
          <input id={option.label} type="checkbox" value={option.value} {...register(name)} />
          <Label id={option.label} label={option.value} />
        </div>
      ))}
    </div>
  </>
);
